module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/left-2-2aaabbf4004b141548e1c3133fa7d891.svg";